import React, {useEffect, useState} from "react";
import {PaginationModel} from "../../models/PaginationModel";
import {
    flexRender,
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    SortingState,
    useReactTable
} from "@tanstack/react-table";
import {deleteRepromaterijalPromet, getAllRepromaterijalPromet} from "../../api/prometRepromaterijala";
import notifyToast from "../../components/Toast/Toast";
import moments from "moment/moment";
import {TableActionButton} from "../../components/TableActionBtn/TableActionButton";
import {Link, useNavigate} from "react-router-dom";
import {KTCard, KTCardBody, KTIcon} from "../../../_websoft/helpers";
import {ToastContainer} from "react-toastify";
import UposlenikDropdown from "../../components/UposlenikDropdown/UposlenikDropdown";
import TableSearch from "../../components/TableSearch/TableSearch";
import ExportButton from "../../components/TableExportToExcel/ExportButton";
import LoadingComponent from "../../components/LoadingComponent/LoadingComponent";
import TablePagination from "../../components/TablePagination/TablePagination";
import {deletePaneliKontrolaKvaliteta, getPaneliKontrolaKvaliteta} from "../../api/paneliKontrolaKvaliteta";
import IndeterminateCheckbox from "../../components/IndeterminateCheckbox/IndeterminateCheckbox";
import TableActiveFilter from "../../components/TableActiveFilter/TableActiveFilter";
import {
    PaneliKontrolaKvalitetaModel,
    ParamsModelKontrola
} from "../../models/PaneliKontrolaKvalitetaModel";

const KontrolaKvalitetaLista:React.FC = () => {
    const [data, setData] = useState<PaneliKontrolaKvalitetaModel[]>([])
    const [loading, setLoading] = useState(true)
    const [params, setparams] = useState<ParamsModelKontrola>({per_page: 10, page: 1})
    const [pagination, setpagination] = useState<PaginationModel>({
        curPage: 1,
        totalPage: 1,
        perPage: 10,
    })

    const [sorting, setSorting] = useState<SortingState>([])
    const [globalFilter, setGlobalFilter] = React.useState('')
    const [columnFilters, setColumnFilters] = useState([])
    const [rowSelection, setRowSelection] = useState({})
    const updatePage = () => {
        setLoading(true)
        getPaneliKontrolaKvaliteta(params)
            .then((response) => {
                setData(response.data['data'])
                const totalPage = Math.floor(response.data['total'] / response.data['per_page'] + 1)
                setpagination({
                    curPage: response.data['current_page'],
                    totalPage: totalPage,
                    perPage: params.per_page,
                })
            })
            .catch((error) => {
                console.error('Error: ', error)
                notifyToast(false, error)
            })
            .finally(() => {
                setLoading(false)
                setRowSelection({})
            })
    }

    useEffect(() => {
        updatePage()
    }, [params])

    useEffect(() => {
        const {id} = sorting[0] ?? ''
        data.sort((a, b) => a[id] - b[id])
    }, [sorting])

    const renderColoredCell = ({ getValue }) => {
        const value = getValue();
        let color = '';

        if (value === 'Da') {
            color = 'green';
        } else if (value === 'Ne') {
            color = 'red';
        }

        return (
            <span style={{color: color, fontWeight: 'bold'}}>
            {value || ''}
        </span>
        );
    };

    const columns = [
        {
            header: 'Id',
            accessorKey: 'Id',
        },
        {
            header: 'Broj naloga',
            accessorKey: 'paneli_proizvodnja.brojNaloga',
        },
        {
            header: 'Vrsta',
            accessorKey: 'paneli_proizvodnja.izolacija_panela.naziv',
        },
        {
            header: 'Tip',
            accessorKey: 'paneli_proizvodnja.tip_panela.Naziv',
        },
        {
            header: 'Artikal',
            accessorKey: 'paneli_proizvodnja.artikal',
        },
        {
            header: 'A1',
            accessorKey: 'TestA1Zadovoljava',
            cell: renderColoredCell,
        },
        {
            header: 'A2',
            accessorKey: 'TestA2Zadovoljava',
            cell: renderColoredCell,
        },
        {
            header: 'A3',
            accessorKey: 'TestA3Zadovoljava',
            cell: renderColoredCell,
        },
        {
            header: 'A4',
            accessorKey: 'TestA4Zadovoljava',
            cell: renderColoredCell,
        },
        {
            header: 'A5',
            accessorKey: 'TestA5Zadovoljava',
            cell: renderColoredCell,
        },
        {
            header: 'A10',
            accessorKey: 'TestA10Zadovoljava',
            cell: renderColoredCell,
        },
        {
            header: 'Deb. lima',
            accessorKey: 'paneli_proizvodnja.debljina_gore.debljina',
            cell: ({ row }) => {
                const debljinaGore = row.original.paneli_proizvodnja.debljina_gore?.debljina;
                const debljinaDole = row.original.paneli_proizvodnja.debljina_dole?.debljina;
                return `${debljinaGore} / ${debljinaDole}`;
            },
        },
        {
            header: 'Boja',
            accessorKey: 'paneli_proizvodnja.boja_gore.BojaNaziv',
            cell: ({ row }) => {
                const bojaGore = row.original.paneli_proizvodnja.boja_gore?.BojaNaziv;
                const bojaDole = row.original.paneli_proizvodnja.boja_dole?.BojaNaziv;
                return `${bojaGore} / ${bojaDole}`;
            },
        },
       /* {
            header: 'Rolne G',
            accessorKey: 'paneli_proizvodnja.rolneG',
        },
        {
            header: 'Rolne D',
            accessorKey: 'paneli_proizvodnja.rolneD',
        },*/
        {
            header: 'Datum',
            accessorFn: (row) => `${moments(row.Kreirano).format('DD-MM-YYYY')}`,
        },
        {
            header: 'Kreirao',
            accessorKey: 'uposlenik.UposlenikImePrezime',
        },
        {
            header: 'Akcija',
            accessorKey: 'Action',
            cell: ({row}) => (
                <TableActionButton
                    onDelete={() => onDelete(row.original.Id)}
                    onEdit={() => {
                        onEdit(row.original.Id)
                    }}
                />
            ),
        },
    ]
    const table = useReactTable({
        data: data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        state: {
            sorting: sorting,
            globalFilter: globalFilter,
            columnFilters: columnFilters,
            rowSelection: rowSelection,
        },
        // @ts-ignore
        onColumnFiltersChange: setColumnFilters,
        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter,
        getFilteredRowModel: getFilteredRowModel(),
        onRowSelectionChange: setRowSelection,
        enableRowSelection: true,
    })
    const onDelete = (id) => {
        deletePaneliKontrolaKvaliteta(id)
            .then((response) => {
                updatePage()
                console.log(response.data.message)
                notifyToast(true, response.data['message'])
            })
            .catch((error) => {
                notifyToast(false, error.data['message'])
            })
    }
    const navigate = useNavigate()

    const onEdit = (rowData) => {
        navigate(`/paneli/kontrola-kvaliteta/izmjena/${rowData}`)
    }

    return (
        <KTCard>
            <ToastContainer />
            <KTCardBody className='py-4'>
                <div className='d-flex justify-content-between'>
                    <div data-kt-user-table-toolbar='base'>
                        <TableSearch onSearch={(text) => setGlobalFilter(text)}/>
                    </div>
                    <div data-kt-user-table-toolbar='base'>
                        <ExportButton table={table} filename={'ugovori'}/>
                        <Link to='/paneli/kontrola-kvaliteta/dodaj'>
                            <button type='button' className='btn btn-primary'>
                                <KTIcon iconName='plus' className='fs-2'/>
                                Dodaj
                            </button>
                        </Link>
                    </div>
                </div>
                {loading ? (
                    <LoadingComponent/>
                ) : (
                    <div className='table-responsive mt-3 '>
                        <table className='table align-middle table-bordered gy-5 no-footer'>
                            <thead>
                            {table.getHeaderGroups().map((headerGroup) => (
                                <tr
                                    key={headerGroup.id}
                                    className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-dark p-2'
                                >
                                    {headerGroup.headers.map((header) => (
                                        <th
                                            className='text-white'
                                            key={header.id}
                                            onClick={header.column.getToggleSortingHandler()}
                                        >
                                            {flexRender(header.column.columnDef.header, header.getContext())}
                                            {/* @ts-ignore */}
                                            {{asc: '🔼', desc: '🔽'}[header.column.getIsSorted() ?? null]}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                            </thead>
                            <tbody className='text-gray-600'>
                            {table.getRowModel().rows && table.getRowModel().rows.length > 0 ? (
                                table.getRowModel().rows.map((row) => (
                                    <tr key={row.id}>
                                        {row.getVisibleCells().map((cell) => (
                                            <td key={cell.id}>
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={7}>
                                        <div
                                            className='d-flex text-center w-100 align-content-center justify-content-center'>
                                            No matching records found
                                        </div>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                )}
                <TablePagination
                    updatePage={(page, per_page) => setparams({...params, page: page, per_page: per_page})}
                    pagination={pagination}
                />
            </KTCardBody>
        </KTCard>
    )
}
export default KontrolaKvalitetaLista;
